<template>
  <div
    :class="['image-resize-handle d-flex align-center justify-center', { resizing: isResizing, 'handle-top': handleOnTop, hovering: isHovering }]"
    @mousedown.prevent.stop="startResize"
  >
    <VIcon x-small class="resize-icon">unfold_more</VIcon>
    <span class="resize-label font-weight-medium">Resize</span>
  </div>
</template>

<script>
export default {
  name: 'LayoutImageResizeHandle',
  props: {
    size: {
      type: Number,
      required: true,
    },
    ratio: {
      type: Number,
      default: 1,
    },
    handleOnTop: {
      type: Boolean,
      default: false,
    },
    isHovering: {
      type: Boolean,
      default: false,
    },
    isResizing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      resizeStartY: 0,
      resizeStartSize: 0,
    }
  },
  beforeDestroy() {
    this.stopResize()
  },
  methods: {
    startResize(event) {
      this.resizeStartY = event.clientY
      this.resizeStartSize = this.size
      this.$emit('resize-start')
      document.addEventListener('mousemove', this.onResize)
      document.addEventListener('mouseup', this.stopResize)
    },
    onResize(event) {
      const delta = this.handleOnTop
        ? this.resizeStartY - event.clientY
        : event.clientY - this.resizeStartY
      const newSize = Math.max(20, Math.min(400, this.resizeStartSize + delta / this.ratio))
      this.$emit('resize', newSize)
    },
    stopResize() {
      this.$emit('resize-end')
      document.removeEventListener('mousemove', this.onResize)
      document.removeEventListener('mouseup', this.stopResize)
    },
  },
}
</script>

<style lang="scss" scoped>
.image-resize-handle {
  position: absolute;
  left: 50%;
  bottom: -16px;
  transform: translateX(-50%);
  gap: 2px;
  padding: 2px 8px;
  cursor: ns-resize;
  background: #e0e0e0;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.15s, background 0.15s;
  user-select: none;

  &.handle-top {
    bottom: auto;
    top: -16px;
  }

  &.hovering {
    opacity: 0.8;
  }

  &:hover,
  &.resizing {
    opacity: 1 !important;
    background: #1976d2;

    .resize-icon,
    .resize-label {
      color: white;
    }
  }
}
.resize-icon {
  color: #757575;
  font-size: 14px !important;
}
.resize-label {
  color: #757575;
  font-size: 11px;
  letter-spacing: 0.02em;
}
</style>
